import { platform } from '../device/platform';
import Cookie, { AUTH_COOKIE_NAME } from './Cookies';
import { updateLastUserFile } from './last-user'
export async function onLogout(): Promise<void> {

    if ( platform === 'web' ){
        Cookie.erase(AUTH_COOKIE_NAME)
    } else {
        return updateLastUserFile()
    }

}